export default __webpack_public_path__ + "../staticImages/apple-icon.png";